/** Templates Word exclusivos del flujo Oficios BCI (fiscalía). */
export const OFICIOS_TEMPLATE_IDS = new Set([9001, 9002, 9003]);

export const OFICIOS_TEMPLATE_BY_ACTION: Record<string, number> = {
  'Generar template sin información': 9001,
  'Generar Documento Sin Copia': 9002,
  'Generar Documento Con Copia': 9003,
};

/** Requerimiento del flujo Oficios / Oficios Informativos (compartido entre componentes). */
export function isOficiosRequirementRecord(requirement: any): boolean {
  if (!requirement) {
    return false;
  }
  const typeName = String(
    requirement.requirementtypename || requirement.type || ''
  );
  const workflow = String(requirement.workflowname || '');
  return (
    typeName === 'Oficio' ||
    typeName === 'Oficio Informativo' ||
    workflow === 'Oficios' ||
    workflow === 'Oficios Informativos'
  );
}
